
/**
 * API 勤怠再計算
 */

export interface RecorderByICCard {
  orgCode: string,
  orgName: string,
  loginOrgCode: string,
  loginOrgName: string,
  cardId: string,
  staffName: string,
  inputCardId: string,
  stampTime: string,
  stampType: number,
  stampMode: number,
  isRemote?: boolean,
}


export default class RecorderByICCardDomain {
  constructor(private rawData: RecorderByICCard) {
  // do nothing
  }

  static generateInitial(): RecorderByICCardDomain {
    return new RecorderByICCardDomain({
      orgCode: '',
      orgName: '',
      loginOrgCode: '',
      loginOrgName: '',
      cardId: '',
      staffName: '',
      inputCardId: '',
      stampTime: '',
      stampType: 0,
      stampMode: 0,
      isRemote: undefined
    });
  }

  getRawData(): RecorderByICCard {
    return this.rawData;
  }

  get orgCode():string {
    return this.rawData.orgCode;
  }

  set orgCode(orgCode:string) {
    this.rawData.orgCode = orgCode;
  }

  get orgName():string {
    return this.rawData.orgName;
  }

  set orgName(orgName:string) {
    this.rawData.orgName = orgName;
  }

  get loginOrgCode():string {
    return this.rawData.loginOrgCode;
  }

  set loginOrgCode(loginOrgCode:string) {
    this.rawData.loginOrgCode = loginOrgCode;
  }

  get loginOrgName():string {
    return this.rawData.loginOrgName;
  }

  set loginOrgName(loginOrgName:string) {
    this.rawData.loginOrgName = loginOrgName;
  }


  get inputCardId():string {
    return this.rawData.inputCardId;
  }

  set inputCardId(inputCardId:string) {
    this.rawData.inputCardId = inputCardId;
  }

  get cardId():string {
    return this.rawData.cardId;
  }

  set cardId(cardId:string) {
    this.rawData.cardId = cardId;
  }

  get staffName():string {
    return this.rawData.staffName;
  }

  set staffName(staffName:string) {
    this.rawData.staffName = staffName;
  }

  get stampTime():string {
    return this.rawData.stampTime;
  }

  set stampTime(stampTime:string) {
    this.rawData.stampTime = stampTime;
  }

  get stampMode():number {
    return this.rawData.stampMode;
  }

  set stampMode(stampMode:number) {
    this.rawData.stampMode = stampMode;
  }

  get stampType():number {
    return this.rawData.stampType;
  }

  set stampType(stampType:number) {
    this.rawData.stampType = stampType;
  }

  get isRemote():boolean|undefined {
    return this.rawData.isRemote;
  }

  set isRemote(isRemote:boolean|undefined) {
    this.rawData.isRemote = isRemote;
  }

  // get

// custom data use DataTable
}
